// eslint-disable-next-line import/no-unresolved
import { useToggles } from 'navbar/components';
import { useNavigate } from 'react-router';

import { useInsuranceOverviewList } from 'Api/insurance';
import { filterPrivate } from 'Components/InsuranceOverviewSection/insuranceOverviewSection.helpers';
import { isAkaAgreement } from 'Utils/agreementCodes/agreementCodes.utils';
import { BRAND_LOGO_URL } from '../themes.constants';
import { Brand } from '../themes.types';
import {
  AKA_AGREEMENT_CODE_TO_UNION_MAP,
  coopCooperation,
  danskeBankCooperation,
} from './partnerTheme.constants';
import { akademikerneCooperation, getAkaLogoUrl } from './partnerTheme.helpers';

export const useGetAkaPartnerLogo = (): string => {
  const { data } = useInsuranceOverviewList();

  if (data.length === 0) {
    return BRAND_LOGO_URL.akademikerne;
  }

  const privateInsurances = filterPrivate(data);
  const akaInsurances = privateInsurances.filter((insurance) =>
    isAkaAgreement(insurance.agreementProduct),
  );
  const firstAkaAgreement = akaInsurances.find(
    (insurance) => insurance.agreementProduct,
  );

  if (firstAkaAgreement) {
    const agreementCode = firstAkaAgreement.agreementProduct;

    const firstUnion = AKA_AGREEMENT_CODE_TO_UNION_MAP[agreementCode];
    const partnerLogo = getAkaLogoUrl(firstUnion);
    return partnerLogo ?? BRAND_LOGO_URL.akademikerne;
  }
  return BRAND_LOGO_URL.akademikerne;
};

export const useGetNavbarCooperation = (brand: Brand) => {
  const akaLogo = useGetAkaPartnerLogo();
  switch (brand) {
    case 'akademikerne':
      return akademikerneCooperation(akaLogo);
    case 'danskeBank':
      return danskeBankCooperation;
    case 'coop':
      return coopCooperation;
    default:
      return null;
  }
};

export const useMenuNavigation = () => {
  const navigate = useNavigate();
  const { closeToggle } = useToggles();
  return (path: string) => {
    closeToggle();
    navigate(path);
  };
};
